import { getEnumValues } from "sprint-common-web";

export enum OrderRequestColumn {
    PoNumber = 1,
    Content = 2,
    Airline = 3,
    System = 4,
    StartDate = 5,
    DueDate = 6,
    Info = 7,
    Video = 8,
    Soundtracks = 9,
    Subtitles = 10,
    Status = 11,
    CreatedDate = 12,
    Runtime = 13,
    TargetFilenames = 14,
    Progress = 15,
    Actions = 16,
    Resolution = 17,
    Source = 18
}

export interface ColumnConfig {
    order: number;
    visible: boolean;
}

export interface OrderRequestListingConfig {
    pageSize: number;
    columns: ConfiguredOrderRequestColumns;
}

type ConfiguredOrderRequestColumns = Record<OrderRequestColumn, ColumnConfig>;

export const getDefaultOrderRequestListingConfig = (): OrderRequestListingConfig => ({
    pageSize: 50,
    columns: {
        [OrderRequestColumn.PoNumber]: { order: 1, visible: true },
        [OrderRequestColumn.Content]: { order: 2, visible: true },
        [OrderRequestColumn.Airline]: { order: 3, visible: true },
        [OrderRequestColumn.System]: { order: 4, visible: true },
        [OrderRequestColumn.StartDate]: { order: 5, visible: true },
        [OrderRequestColumn.DueDate]: { order: 6, visible: true },
        [OrderRequestColumn.Progress]: { order: 7, visible: true },
        [OrderRequestColumn.Info]: { order: 8, visible: true },
        [OrderRequestColumn.Source]: { order: 9, visible: true },
        [OrderRequestColumn.TargetFilenames]: { order: 10, visible: true },
        [OrderRequestColumn.Runtime]: { order: 11, visible: true },
        [OrderRequestColumn.Resolution]: { order: 12, visible: true },
        [OrderRequestColumn.Video]: { order: 13, visible: true },
        [OrderRequestColumn.Soundtracks]: { order: 14, visible: true },
        [OrderRequestColumn.Subtitles]: { order: 15, visible: true },
        [OrderRequestColumn.Status]: { order: 16, visible: true },
        [OrderRequestColumn.CreatedDate]: { order: 17, visible: true },
        [OrderRequestColumn.Actions]: { order: 18, visible: true }
    }
});

export const getSortedOrderColumns = (columnConfig: ConfiguredOrderRequestColumns): [string, ColumnConfig][] => {
    /* ensures that columns not present in LocalStorage config (i.e. newly added) are present in the listing config modal */
    const allColumns: ConfiguredOrderRequestColumns = { ...getInvisibleDefaultColumns(), ...columnConfig };
    const supportedColumns = new Set(getEnumValues(OrderRequestColumn));

    return (
        Object.entries(allColumns)
            /* ensures no unrecognized values are displayed in the config dialog */
            .filter(([columnKey]) => supportedColumns.has(Number(columnKey)))
            .sort(([, valueA], [, valueB]) => {
                const columnA = valueA.order;
                const columnB = valueB.order;
                return columnA - columnB;
            })
    );
};

const getInvisibleDefaultColumns = () => {
    const defaultColumns = getDefaultOrderRequestListingConfig().columns;
    const entries = Object.entries(defaultColumns).map(([colName, colCfg]) => [colName, { ...colCfg, visible: false }]);

    return Object.fromEntries(entries);
};
